export interface Props {
    type: BrandType;
};

export enum BrandType {
    LogoWithTextUnder = 'logo_with_text_under',
    LogoWithTextRight = 'logo_with_text_right',
};